module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('div', {
    staticStyle: {
      "background-color": "white",
      "position": "absolute",
      "top": "0px",
      "right": "0px",
      "z-index": "1000"
    }
  }, [_c('ImageEditor', {
    attrs: {
      "item": _vm.contact
    }
  })], 1), _vm._v(" "), _c('v-text-field', {
    ref: "firstName",
    attrs: {
      "label": "First Name",
      "rules": _vm.requiredRules
    },
    on: {
      "change": _vm.checkGenderAndDuplicates
    },
    model: {
      value: (_vm.contact.firstName),
      callback: function($$v) {
        _vm.$set(_vm.contact, "firstName", $$v)
      },
      expression: "contact.firstName"
    }
  }), _vm._v(" "), (_vm.advanced) ? _c('v-text-field', {
    attrs: {
      "label": "Preferred Name"
    },
    model: {
      value: (_vm.contact.preferredName),
      callback: function($$v) {
        _vm.$set(_vm.contact, "preferredName", $$v)
      },
      expression: "contact.preferredName"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Last Name",
      "rules": _vm.requiredRules
    },
    on: {
      "change": _vm.checkDuplicates
    },
    model: {
      value: (_vm.contact.lastName),
      callback: function($$v) {
        _vm.$set(_vm.contact, "lastName", $$v)
      },
      expression: "contact.lastName"
    }
  }), _vm._v(" "), _c('UniqueContactEnforcer', {
    ref: "enforcer",
    attrs: {
      "contact": _vm.contact
    }
  }), _vm._v(" "), (_vm.advanced || _vm.contact.business) ? _c('v-text-field', {
    attrs: {
      "label": "Business"
    },
    model: {
      value: (_vm.contact.business),
      callback: function($$v) {
        _vm.$set(_vm.contact, "business", $$v)
      },
      expression: "contact.business"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.advanced || _vm.contact.phone) ? _c('v-text-field', {
    attrs: {
      "label": "Phone"
    },
    model: {
      value: (_vm.contact.phone),
      callback: function($$v) {
        _vm.$set(_vm.contact, "phone", $$v)
      },
      expression: "contact.phone"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Mobile",
      "rules": _vm.mobileRules
    },
    model: {
      value: (_vm.contact.mobile),
      callback: function($$v) {
        _vm.$set(_vm.contact, "mobile", $$v)
      },
      expression: "contact.mobile"
    }
  }), _vm._v(" "), (_vm.advanced || _vm.contact.fax) ? _c('v-text-field', {
    attrs: {
      "label": "Fax "
    },
    model: {
      value: (_vm.contact.fax),
      callback: function($$v) {
        _vm.$set(_vm.contact, "fax", $$v)
      },
      expression: "contact.fax"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.advanced || _vm.contact.address) ? _c('v-text-field', {
    attrs: {
      "label": "Address "
    },
    model: {
      value: (_vm.contact.address),
      callback: function($$v) {
        _vm.$set(_vm.contact, "address", $$v)
      },
      expression: "contact.address"
    }
  }) : _vm._e(), _vm._v(" "), _c('EmailBox', {
    ref: "email",
    attrs: {
      "hide-details": false
    },
    model: {
      value: (_vm.contact.email),
      callback: function($$v) {
        _vm.$set(_vm.contact, "email", $$v)
      },
      expression: "contact.email"
    }
  }), _vm._v(" "), _c('v-combobox', {
    attrs: {
      "multiple": "",
      "value": _vm.selectedGroups,
      "label": "Groups",
      "chips": "",
      "items": _vm.availableGroups
    },
    on: {
      "input": _vm.updateGroups
    }
  }), _vm._v(" "), (_vm.advanced) ? _c('v-textarea', {
    attrs: {
      "label": "Notes"
    },
    model: {
      value: (_vm.contact.notes),
      callback: function($$v) {
        _vm.$set(_vm.contact, "notes", $$v)
      },
      expression: "contact.notes"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.advanced) ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.advanced = true
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_down")]), _vm._v("Advanced")], 1) : _vm._e(), _vm._v(" "), (_vm.advanced) ? _c('v-select', {
    attrs: {
      "clearable": "",
      "items": ['Male', 'Female', 'Other'],
      "label": "Gender"
    },
    on: {
      "change": _vm.checkImage
    },
    model: {
      value: (_vm.contact.gender),
      callback: function($$v) {
        _vm.$set(_vm.contact, "gender", $$v)
      },
      expression: "contact.gender"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.advanced) ? _c('v-text-field', {
    attrs: {
      "label": "Middle Name"
    },
    model: {
      value: (_vm.contact.middleName),
      callback: function($$v) {
        _vm.$set(_vm.contact, "middleName", $$v)
      },
      expression: "contact.middleName"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.advanced) ? _c('DateTime', {
    attrs: {
      "date-only": "",
      "label": "Date of Birth",
      "short": ""
    },
    model: {
      value: (_vm.contact.dob),
      callback: function($$v) {
        _vm.$set(_vm.contact, "dob", $$v)
      },
      expression: "contact.dob"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-select', {
    attrs: {
      "clearable": "",
      "items": _vm.users,
      "label": "Owner",
      "item-text": "meta.fullName",
      "item-value": "key",
      "return-object": ""
    },
    model: {
      value: (_vm.contact.owner),
      callback: function($$v) {
        _vm.$set(_vm.contact, "owner", $$v)
      },
      expression: "contact.owner"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "disabled": Boolean(_vm.contact.meta.key),
      "items": _vm.officesList,
      "label": "Office",
      "item-text": "name",
      "item-value": "meta.key"
    },
    model: {
      value: (_vm.contact.meta.tenantKey),
      callback: function($$v) {
        _vm.$set(_vm.contact.meta, "tenantKey", $$v)
      },
      expression: "contact.meta.tenantKey"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-093a6fe1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/ContactDetails.vue
// module id = 2441
// module chunks = 1